__turbopack_context__.v({
  "image": "PriceConfigurator-module__wxU6KW__image",
  "images": "PriceConfigurator-module__wxU6KW__images",
  "modalCaption": "PriceConfigurator-module__wxU6KW__modalCaption",
  "modalImage": "PriceConfigurator-module__wxU6KW__modalImage",
  "modalImageContainer": "PriceConfigurator-module__wxU6KW__modalImageContainer",
  "zoomIcon": "PriceConfigurator-module__wxU6KW__zoomIcon",
});
